<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? 'Update device' : 'Add new device'" subtitle="Provide the main details of the Device in this section." class="py-8 border-b">
                <ui-input label="Name" name="name" :error="form.errors.get('name')" v-model="form.name"></ui-input>
                <ui-textarea label="Description" name="description" :error="form.errors.get('description')" v-model="form.description"></ui-textarea>
                <ui-input label="Serial Number" name="serial" :error="form.errors.get('serial')" v-model="form.serial"></ui-input>
                <ui-select-searchable
                    class="col-span-12"
                    label="Assigned to"
                    v-model="form.person_id"
                    :error="form.errors.get('person_id')"
                    :search="searchContact"
                ></ui-select-searchable>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import { Device, Contact } from '@models'

export default {
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {}

        return {
            form: new Form(initialData, async (form) => {
                if (this.editMode) {
                    await this.item.update(form.export())
                    this.edit(false)
                } else {
                    const device = await Device.create(form.export())
                    this.addItem(device, 0)

                    form.reset()
                }
            }),
        }
    },
    methods: {
        async searchContact (query) {
            return (await Contact.search(query)).map(x => x.toDropdown())
        },
    },
    computed: {
        editMode () {
            return !! this.item
        },
    },
}
</script>
